
import { defineComponent, computed, PropType, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ScreenInfo } from '@/types'
import MenuPopOver from './MenuPopOver.vue'

export default defineComponent({
  name: 'Menu',

  components: {
    MenuPopOver,
  },

  props: {
    screenInfo: {
      type: Object as PropType<ScreenInfo>,
      default: undefined,
    },
  },

  setup (props) {
    const menuContainer = ref<HTMLElement | null>(null)
    const isHoverService = ref(false)
    const scrollTop = ref(0)
    const showUp = ref(true)
    const router = useRouter()
    const path = computed(() => router.currentRoute.value.name)

    const bulletClass = (menuItem: string) => path.value === menuItem ? 'bullet active' : 'bullet'

    const menuStyle = computed(() => {
      if (path.value === 'Home' && props.screenInfo?.isPlatform === 'mobile') {
        return 'menu home-mobile'
      } else if (path.value === 'Home') {
        return 'menu home'
      } else if (props.screenInfo?.isPlatform === 'mobile') {
        return 'menu mobile'
      } else {
        return 'menu'
      }
    })

    const liStyle = (menuItem: string) => path.value === menuItem ? 'visit' : ''

    const onMouseOver = () => {
      isHoverService.value = true
    }

    const onMouseLeave = () => {
      isHoverService.value = false
    }

    const onClickItem = () => {
      window.open('https://home.bizplat.app')
      isHoverService.value = false
    }

    window.addEventListener('scroll', () => {
      scrollTop.value = document.documentElement.scrollTop
      const offsetTop = menuContainer.value?.offsetTop as number
      if (scrollTop.value <= offsetTop / 2) {
        showUp.value = true
      } else {
        showUp.value = false
      }
    })

    return {
      router,
      path,
      menuStyle,
      showUp,
      liStyle,
      bulletClass,
      onMouseOver,
      onMouseLeave,
      isHoverService,
      onClickItem,
      menuContainer,
    }
  },
})
